export const Browser = {
  doesSupportMsSaveBlob: () => {
    return navigator.msSaveBlob;
  },

  doesSupportModernAnchorAttributes: () => {
    const link = document.createElement("a");
    return (
      typeof link.download === "string" && typeof link.remove === "function"
    );
  },

  doesSupportURL: () => {
    return URL && URL.createObjectURL;
  }
};
